import { PropsWithChildren } from 'react';

import { BillboardTypedLink } from './BillboardTypedLink';
import { TypedLink } from './models';

interface Props {
  links?: TypedLink[];
  darkBackground?: boolean;
}

export function BillboardPreamble({
  children,
  links = [],
  darkBackground = false,
}: PropsWithChildren<Props>) {
  return (
    <div className="billboard-preamble">
      {children}
      {links.map((link) => (
        <BillboardTypedLink
          key={link.name}
          type={link.type}
          href={link.href}
          name={link.name}
          openInNewTab={link.openInNewTab}
          darkBackground={darkBackground}
        />
      ))}
    </div>
  );
}
